import React from 'react';
import PropTypes from 'prop-types';

const FemaleResidentLandlord = ({ color = '#224251', fillColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#a)">
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m18.338 4.7.002-.005m-2.468-1.337 2.222-1.455a1.5 1.5 0 0 1 2.076.433l1.067 1.63a1.501 1.501 0 0 1-.432 2.076l-.186.122 2.648 4.044c.135.205.192.45.164.694l-.015.09-.125.598a.521.521 0 0 1-.556.413l-.06-.01-.598-.124a1.043 1.043 0 0 1-.606-.375l-.053-.074-.168-.256.213-1.02-1.02-.213.212-1.02-1.02-.213-.866-1.323-.186.122a1.5 1.5 0 0 1-2.076-.433l-1.068-1.63a1.497 1.497 0 0 1 .433-2.076ZM7.533 17.401c-3.2.55-6.66.437-6.66 3.585v2.459H18v-2.46c0-3.148-3.687-3.014-7.004-3.584M9.07 18.158l-.007 5.288"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M11.298 20.046a.376.376 0 0 0-.373.378c0 .208.167.377.373.377.205 0 .372-.169.372-.377a.376.376 0 0 0-.372-.378ZM7.192 20.076a.376.376 0 0 0-.373.378c0 .209.167.378.373.378.205 0 .372-.17.372-.378a.376.376 0 0 0-.372-.378ZM11.298 21.556a.376.376 0 0 0-.373.378c0 .208.167.377.373.377.205 0 .372-.169.372-.377a.376.376 0 0 0-.372-.378ZM7.192 21.554a.376.376 0 0 0-.373.378c0 .208.167.378.373.378.205 0 .372-.17.372-.378a.376.376 0 0 0-.372-.378Z"
        clipRule="evenodd"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.877 14.585c0 1.93 3.582 3.089 4.75.386-3.503 0-.779-11.97-8.564-8.108C1.278 3.002 4.003 14.97.5 14.97c1.168 2.703 4.757 1.544 4.757-.386"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.134 18.183c1.142-.386 3.425-1.544 3.806-3.86 1.142 0 1.142-2.318 0-2.318l-.38-1.544c-3.045 0-3.045-1.158-3.426-1.544-.38.386-.38 1.544-3.425 1.544l-.38 1.544c-1.143 0-1.143 2.317 0 2.317.38 2.317 2.663 3.475 3.805 3.861v0Z"
        clipRule="evenodd"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.854 12.123c0-.427.34-.386.761-.386s.762-.04.762.386M9.634 12.123c0-.427.34-.386.761-.386s.762-.04.762.386"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={fillColor} d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

FemaleResidentLandlord.propTypes = {
  color: PropTypes.string,
  fillColor: PropTypes.string
};

export default FemaleResidentLandlord;
